import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { withRouter, } from "react-router-dom";
import { Button, Icon, Input, Tab, Table } from "semantic-ui-react";
import { AuthStore } from "../../stores/auth-store";
import { User, UserType } from "../../stores/models/user";
import { UserStore } from "../../stores/user-store";
import { LoadingSpinner } from "../common/loading-spinner";

interface IUserViewProps{
	userStore?: UserStore;
	authStore?: AuthStore;
	history?: any;
}

interface IUserViewState{
	errorMessage?: string;
	showEditor?: boolean;
	selectedUser?: User;
	working?: boolean;
	searchTerm?: string;
}

@inject("userStore", "authStore") @observer
export class UserView extends React.Component<IUserViewProps, IUserViewState>{
	constructor(props, state){
		super(props, state);

		this.state = {"showEditor": false, "working": false};

		this.handleCreateUser = this.handleCreateUser.bind(this);
		this.handleEditUser = this.handleEditUser.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleImpersonateUser = this.handleImpersonateUser.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
	}

	async componentDidMount(){
		try{
			await this.props.userStore.loadUsers(true);
		}
		catch(err){
			log.error(err);
			this.setState({"errorMessage": err.message});
		}
	}

	handleCreateUser(){
		this.setState({"showEditor": true, "selectedUser": new User()});
	}

	handleEditUser(user: User){

		this.setState({"showEditor": true, "selectedUser": user});
	}

	handleClose(){
		this.setState({"showEditor": false});
	}

	async handleImpersonateUser(userId){
		try{
			await this.props.authStore.impersonate(userId);
			this.props.history.push("/");
			location.reload();
		}
		catch(err){
			log.error(err);
			this.setState({"errorMessage": err.message});
		}
	}

	async handlePurgeUser(userId: string){
		try{
			this.setState({"working": true});
			await this.props.userStore.purge(userId);
		}
		catch(err){
			log.error(err);
			this.setState({"errorMessage": err.message});
		}
		finally{
			this.setState({"working": false});
		}

		try{
			await this.props.userStore.loadUsers(true);
		}
		catch(err){
			log.error(err);
			this.setState({"errorMessage": err.message});
		}
	}

	handleSearchChange(e){
		this.setState({"searchTerm": e.target.value});
	}

	render(){
		let userStore = this.props.userStore;
		let externalUsers = userStore.externalUsers;
		let internalUsers = userStore.internalUsers;

		if(this.state.searchTerm){
			externalUsers = externalUsers.filter(user => {
				return user.username.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) > -1;
			});

			internalUsers = internalUsers.filter(user => {
				return user.username.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) > -1;
			});
		}

		let panes = [
			{"menuItem": "External Users", "render": () => {
				return(
					<Table basic>
						<Table.Body>
						{externalUsers.map((user) => {
							return(
								<Table.Row key={user.id} className="table-row-hover">
									<Table.Cell>{user.username}</Table.Cell>
									<Table.Cell style={{"textAlign": "right"}}>
									{
										this.props.authStore.user.hasJumpAccess(user.userType) &&
										<Button className="jibunu-blue" onClick={() => this.handleImpersonateUser(user.id)}>Impersonate</Button>
									}
									</Table.Cell>
									{
										this.props.authStore.user.ableToPurgeUser() &&
										<Table.Cell style={{"textAlign": "right"}}>
											<Button className="jibunu-red" onClick={() => this.handlePurgeUser(user.id)}>Purge</Button>
										</Table.Cell>
									}
								</Table.Row>
							);
						})}
						</Table.Body>
					</Table>
				);
			}},
			{"menuItem": "Internal Users", "render": () => {
				return(
					<Table basic>
						<Table.Body>
						{internalUsers.map((user) => {
							return(
								<Table.Row key={user.id} onClick={() => this.handleEditUser(user)} className="table-row-hover">
									<Table.Cell>{user.username} ({user.userType})</Table.Cell>
									<Table.Cell style={{"textAlign": "right"}}>
									{
										this.props.authStore.user.hasJumpAccess(user.userType) && 
										<Button className="jibunu-blue" onClick={() => this.handleImpersonateUser(user.id)}>Impersonate</Button>
									}
									</Table.Cell>
								</Table.Row>
							);
						})}
						</Table.Body>
					</Table>
				);
			}}
		];

		return (
			<div style={{"marginTop": "95px", "marginLeft": "150px", "marginRight": "150px"}}>
				{this.state.errorMessage &&
					<div className="ui red icon message">
						<i className="warning sign icon"></i>
						{this.state.errorMessage}
					</div>
				}
				<Input fluid icon={<Icon name="search" inverted circular link />} placeholder="Search..." value={this.state.searchTerm} onChange={this.handleSearchChange}/>
				<br /><br />
				<Tab panes={panes}>
				</Tab>
				{this.props.userStore.loading &&
					<LoadingSpinner text="Loading Users" />
				}
				{this.state.working &&
					<LoadingSpinner text="Working" />
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/users/user-view.tsx